import { IHTTPCompletedResponse } from '@cian/http-api/shared/types';

export const parseResponse = (defaultError: string) => (response: IHTTPCompletedResponse) => {
  if (response.responseStatusCode >= 200 && response.responseStatusCode <= 300) {
    return JSON.parse(response.responseBody);
  } else {
    let error;
    try {
      error = JSON.parse(response.responseBody);
    } catch (e) {
      error = { message: defaultError };
    }
    throw error;
  }
};
